import axios from "axios";

/**
 * Axios 0.21 CancelToken cancellations are plain objects (`__CANCEL__: true`),
 * not Error instances, and `cancel()` with no message leaves `message` unset.
 */
export function isRequestCanceled(error: unknown): boolean {
  if (axios.isCancel(error)) {
    return true;
  }

  if (!error || typeof error !== "object") {
    return false;
  }

  const err = error as {
    name?: string;
    code?: string;
    message?: string;
    __CANCEL__?: boolean;
  };

  return (
    err.__CANCEL__ === true ||
    err.name === "CanceledError" ||
    err.name === "AbortError" ||
    err.code === "ERR_CANCELED" ||
    (typeof err.message === "string" &&
      err.message.toLowerCase().includes("cancel"))
  );
}

/** Rollbar.js requires a string or Error as the first argument. */
export function toRollbarError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === "string" && error) {
    return new Error(error);
  }

  const message =
    error &&
    typeof error === "object" &&
    typeof (error as { message?: unknown }).message === "string"
      ? (error as { message: string }).message
      : "";

  return new Error(message || "Unknown error");
}
